<template>
  <div
    class="rounded-lg border border-gray-200 bg-gray-50 text-xs"
    data-cy="webhook-verification-snippet"
  >
    <div
      class="flex flex-wrap items-center gap-1 border-b border-gray-200 px-2 py-1"
      role="tablist"
      aria-label="Language"
    >
      <button
        v-for="snippet in VERIFICATION_SNIPPETS"
        :key="snippet.key"
        type="button"
        role="tab"
        class="rounded px-2 py-1 font-medium"
        :class="
          selected.key === snippet.key
            ? 'bg-white text-blue-700 shadow-sm'
            : 'text-gray-600 hover:bg-gray-100'
        "
        :aria-selected="selected.key === snippet.key"
        :data-cy="`webhook-snippet-tab:${snippet.key}`"
        @click="selectedKey = snippet.key"
      >
        {{ snippet.label }}
      </button>
      <button
        type="button"
        class="ml-auto rounded px-2 py-1 font-medium text-blue-700 hover:bg-blue-50"
        data-cy="webhook-snippet-copy"
        @click="copy"
      >
        {{ copied ? "Copied" : "Copy" }}
      </button>
    </div>
    <pre
      class="m-0 overflow-x-auto px-3 pt-2 font-mono text-gray-500"
      data-cy="webhook-snippet-install"
      >{{ selected.install }}</pre>
    <pre
      class="m-0 overflow-x-auto px-3 py-2 font-mono text-gray-900"
      data-cy="webhook-snippet-code"
      >{{ selected.code }}</pre>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import { VERIFICATION_SNIPPETS } from "./webhooksHub";

const selectedKey = ref(VERIFICATION_SNIPPETS[0].key);
const copied = ref(false);

const selected = computed(
  () =>
    VERIFICATION_SNIPPETS.find((s) => s.key === selectedKey.value) ??
    VERIFICATION_SNIPPETS[0]
);

async function copy() {
  try {
    await navigator.clipboard.writeText(selected.value.code);
    copied.value = true;
    setTimeout(() => (copied.value = false), 2000);
  } catch {
    window.notify.error("Couldn't copy. Select the code and copy it instead.");
  }
}
</script>
